import { Component, inject } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { InputTextModule } from 'primeng/inputtext';
import { DropdownModule } from 'primeng/dropdown';
import {
  BitflagCheckboxGroupControlComponent,
  BitflagOption,
  EmailControlComponent,
  InternationalPhoneControlComponent,
} from '@ep/shared';
import { RepresentativeFormService } from '@app/areas/admin/representatives/services/representative-form.service';
import { LanguageTypes, RepresentativeAccessTypes, RepresentativeTypes } from '@shared/enums';

@Component({
  selector: 'app-representative-form',
  templateUrl: './representative-form.component.html',
  styleUrls: ['./representative-form.component.scss'],
  standalone: true,
  imports: [
    InputTextModule,
    DropdownModule,
    ReactiveFormsModule,
    BitflagCheckboxGroupControlComponent,
    EmailControlComponent,
    InternationalPhoneControlComponent,
  ],
})
export class RepresentativeFormComponent {
  private readonly representativeFormService = inject(RepresentativeFormService);

  protected representativeForm = this.representativeFormService.getForm();

  protected languageOptions = [
    { name: 'English', value: LanguageTypes.English },
    { name: 'Spanish', value: LanguageTypes.Spanish },
    { name: 'French', value: LanguageTypes.French },
  ];

  protected accessTypeOptions: BitflagOption[] = [
    { label: 'Merchant Admin', value: RepresentativeAccessTypes.MerchantAdmin },
    { label: 'Loyalty Program Admin', value: RepresentativeAccessTypes.LoyaltyProgramAdmin },
    { label: 'Billing', value: RepresentativeAccessTypes.Billing },
    { label: 'Representative Admin', value: RepresentativeAccessTypes.RepresentativeAdmin },
    { label: 'Offer Admin', value: RepresentativeAccessTypes.OfferAdmin },
    { label: 'Consumer Admin', value: RepresentativeAccessTypes.ConsumerAdmin },
    { label: 'Team Admin', value: RepresentativeAccessTypes.TeamAdmin },
  ];

  protected representativeTypeOptions: BitflagOption[] = [
    { label: 'Admin', value: RepresentativeTypes.Admin },
    { label: 'Support', value: RepresentativeTypes.Support },
    { label: 'Sales', value: RepresentativeTypes.Sales },
  ];
}
